// extracted by mini-css-extract-plugin
export var card = "_mp-0";
export var content = "_mp-2";
export var details = "_mp-3";
export var icon = "_mp-1";
export var iconBlue = "_mp-5";
export var iconBrand = "_mp-4";
export var iconGrayBlue = "_mp-6";
export var iconGreen = "_mp-7";
export var iconIndigo = "_mp-8";
export var iconOrange = "_mp-9";
export var iconPurple = "_mp-a";
export var iconRed = "_mp-b";
export var iconWarning = "_mp-c";